import { pricesById, variationsPricesById } from "./pricesByEnv";
import { omit } from "client-server-shared/utils/lodash-methods";
export enum Interval {
  "monthly" = "monthly",
  "yearly" = "yearly",
}

export enum PlanName {
  "free" = "Free",
  "standard" = "Standard",
  "creator" = "Standard",
  "unlimited" = "Unlimited",
  "pro" = "Premium",
  appSumo = "AppSumo",
  appSumoTier1 = "AppSumo Tier 1",
  appSumoTier2 = "AppSumo Tier 2",
  appSumoTier3 = "AppSumo Tier 3",
  appSumoTier4 = "AppSumo Tier 4",
}

interface FeatureType {
  description: string;
  disabled?: boolean;
}

const proVariant1 = {
  wordsPerMonth: 200000,
  maxTeamSize: 4,
  workflowsPerMonth: 70,
  aiImages: 300,
  features: [
    {
      description: `<span class="highlighted-span">70</span> Blog Post Workflows (Ready to Rank, Auto-Generated Articles)`,
      info: "Each article can include over 6000 words, optimized by 5+ custom-trained AI models for maximum quality on top of GPT4, automated keyword research, competitor analysis, and more.",
    },
    {
      description: `<span class="highlighted-span">200,000 </span>words/month`,
      info: "Approximately 120 articles co-written with the AI Text Editor",
    },
    {
      description: "Bulk Generate Articles",
    },
    {
      description: "Generate 6000+ word articles",
    },
    /*
  {
    description: "Rewrite Competitors' Articles",
    info: "Convert competitors' articles into your own unique pieces. No more keyword research or content idea struggle.",
  },
  */
    {
      description: "Parasite SEO Integration",
      info: `Publish content with one click to Parasite SEO platforms, such as Medium and Reddit, and dominate Search Engine Results Pages with ease.`,
    },
    {
      description: "Reveal Competitors' Keywords",
      info: `Find out what search intents, keywords and entities your competitors are using in their content and include them in your own articles.`,
    },
    {
      description: "Unlimited Brand Voice (Custom Tone of Voice)",
    },
    {
      description: "Unlimited Knowledge Assets (Infobase)",
    },
    {
      description: "Unlimited Advanced Blog Outline Creation",
      info: `Designed for power users to overcome the limitations of one-click content generation, this is perfect for custom content such as opinionated articles, news pieces, and journalism. Create a draft that includes all necessary sections, headings, keywords, and talking points in just minutes.`,
    },
    {
      description: "Invite Team Members",
    },
    {
      description: "Access to Latest features",
    },
  ],
};
const proVariant2 = {
  wordsPerMonth: 400000,
  maxTeamSize: 5,
  workflowsPerMonth: 150,
  aiImages: 500,
  features: [
    {
      description: `<span class="highlighted-span">150</span> Blog Post Workflows (Ready to Rank, Auto-Generated Articles)`,
      info: "Each article can include over 6000 words, optimized by 5+ custom-trained AI models for maximum quality on top of GPT4, automated keyword research, competitor analysis, and more.",
    },
    {
      description: `<span class="highlighted-span">400,000 </span>words/month`,
      info: "Approximately 240 articles co-written with the AI Text Editor",
    },
    {
      description: "Bulk Generate Articles",
    },
    {
      description: "Generate 6000+ word articles",
    },
    /*
  {
    description: "Rewrite Competitors' Articles",
    info: "Convert competitors' articles into your own unique pieces. No more keyword research or content idea struggle.",
  },
  */
    {
      description: "Parasite SEO Integration",
      info: `Publish content with one click to Parasite SEO platforms, such as Medium and Reddit, and dominate Search Engine Results Pages with ease.`,
    },
    {
      description: "Reveal Competitors' Keywords",
      info: `Find out what search intents, keywords and entities your competitors are using in their content and include them in your own articles.`,
    },
    {
      description: "Unlimited Brand Voice (Custom Tone of Voice)",
    },
    {
      description: "Unlimited Knowledge Assets (Infobase)",
    },
    {
      description: "Unlimited Advanced Blog Outline Creation",
      info: `Designed for power users to overcome the limitations of one-click content generation, this is perfect for custom content such as opinionated articles, news pieces, and journalism. Create a draft that includes all necessary sections, headings, keywords, and talking points in just minutes.`,
    },
    {
      description: "Invite Team Members",
    },
    {
      description: "Access to Latest features",
    },
  ],
};

const proVariant3 = {
  wordsPerMonth: 800000,
  maxTeamSize: 6,
  workflowsPerMonth: 300,
  aiImages: 700,
  features: [
    {
      description: `<span class="highlighted-span">300</span> Blog Post Workflows (Ready to Rank, Auto-Generated Articles)`,
      info: "Each article can include over 6000 words, optimized by 5+ custom-trained AI models for maximum quality on top of GPT4, automated keyword research, competitor analysis, and more.",
    },
    {
      description: `<span class="highlighted-span">800,000 </span>words/month`,
      info: "Approximately 480 articles co-written with the AI Text Editor",
    },
    {
      description: "Bulk Generate Articles",
    },
    {
      description: "Generate 6000+ word articles",
    },
    /*
  {
    description: "Rewrite Competitors' Articles",
    info: "Convert competitors' articles into your own unique pieces. No more keyword research or content idea struggle.",
  },
  */
    {
      description: "Parasite SEO Integration",
      info: `Publish content with one click to Parasite SEO platforms, such as Medium and Reddit, and dominate Search Engine Results Pages with ease.`,
    },
    {
      description: "Reveal Competitors' Keywords",
      info: `Find out what search intents, keywords and entities your competitors are using in their content and include them in your own articles.`,
    },
    {
      description: "Unlimited Brand Voice (Custom Tone of Voice)",
    },
    {
      description: "Unlimited Knowledge Assets (Infobase)",
    },
    {
      description: "Unlimited Advanced Blog Outline Creation",
      info: `Designed for power users to overcome the limitations of one-click content generation, this is perfect for custom content such as opinionated articles, news pieces, and journalism. Create a draft that includes all necessary sections, headings, keywords, and talking points in just minutes.`,
    },
    {
      description: "Invite Team Members",
    },
    {
      description: "Access to Latest features",
    },
  ],
};

const proVariantMonthly = [
  {
    priceIds: [variationsPricesById.proPlanMonthly[0]],
    unit_amount: "8900",
    ...proVariant1,
  },
  {
    priceIds: [variationsPricesById.proPlanMonthly[1]],
    unit_amount: "15900",
    ...proVariant2,
  },
  {
    priceIds: [variationsPricesById.proPlanMonthly[2]],
    unit_amount: "29900",
    ...proVariant3,
  },
];
const proVariantYearly = [
  {
    priceIds: [
      variationsPricesById.proPlanYearly[0],
      variationsPricesById.proPlanYearly[3],
    ],
    unit_amount: "6900",
    ...proVariant1,
  },
  {
    priceIds: [variationsPricesById.proPlanYearly[1]],
    unit_amount: "12600",
    ...proVariant2,
  },
  {
    priceIds: [variationsPricesById.proPlanYearly[2]],
    unit_amount: "23900",
    ...proVariant3,
  },
];

const proVariants = [...proVariantMonthly, ...proVariantYearly];

export interface PlanType {
  planName: string;
  description?: string;
  wordsPerMonth: number;
  maxTeamSize?: number;
  aiImages: number;
  priceIds: string[];
  variants?: typeof proVariants[number][];
  currency: string;
  label?: string;
  type: string;
  interval: string;
  unit_amount: string;
  features: FeatureType[];
  advancedWordsPerMonth: number;
  workflowsPerMonth: number;
}

const creatorFeatures = [
  {
    description: "30000 credits/month",
    info: "1 credit equals approximately 1 word.",
  },
  {
    description: "Premium AI models",
    info: "This includes GPT-4o and Claude 3.5 Sonnet",
  },
  {
    description: "Real-time factual data",
  },
  {
    description: "AI-powered SEO optimization",
  },
  {
    description: "Access to 200+ AI writing tools",
  },
];
const unlimitedFeatures = [
  {
    description: "Unlimited AI-written words",
  },
  {
    description: "100,000 GPT-4 words/month",
  },
  {
    description: "Unlimited auto-generated article",
  },
  {
    description: "Generate 4000+ word articles",
  },
  {
    description: "35 blog post workflows",
  },
  {
    description: "Invite Team Members",
  },
  {
    description: "Access to Latest features",
  },
];
const proFeatures = [
  {
    description: "120000 credits/month",
    info: "1 credit equals approximately 1 word.",
  },
  {
    description: "Invite Team Members",
  },
  {
    description: "Integrations: Medium, Shopify, WordPress, Webflow",
  },
  {
    description: "Access to Latest features",
  },
];

export const freeTrial = {
  planName: PlanName.free,
  label: "Free",
  description: "Experience the power of AI writing with our free plan.",
  priceId: "",
  product_id: "",
  currency: "USD",
  type: "recurring",
  interval: "year",
  unit_amount: "0",
  features: [
    {
      description: "10,000 words",
    },
    {
      description: "50+ content templates",
    },
    {
      description: "No credit card required",
    },
  ],
};

const unlimitedCommonData = {
  wordsPerMonth: 100000,
  maxTeamSize: 3,
  advancedWordsPerMonth: 100000,
  workflowsPerMonth: 35,
  imageRestores: 100,
  aiImages: 200,
  description: "Ideal for large-scale content creation.",
};

const proCommonData = {
  wordsPerMonth: 120000,
  maxTeamSize: 3,
  advancedWordsPerMonth: 0,
  workflowsPerMonth: 35,
  imageRestores: 100,
  aiImages: 200,
  description: "For scaling your content creation.",
};

const creatorCommonData = {
  wordsPerMonth: 100000,
  imageRestores: 100,
  aiImages: 100,
  advancedWordsPerMonth: 0,
  workflowsPerMonth: 10,
  description: "For bloggers, freelancers, and individual creators alike.",
};

const creatorNewCommonData = {
  wordsPerMonth: 30000,
  imageRestores: 100,
  aiImages: 100,
  advancedWordsPerMonth: 0,
  workflowsPerMonth: 5,
  description: "For light usage of AI writing tools.",
};

const creatorCommonDataCn = {
  ...creatorCommonData,
  description: "非常适合博客作者、自由职业者、企业和个人创作者等",
};

export const proMonthly: PlanType = {
  planName: PlanName.pro,
  priceIds: pricesById.proPlanMonthly,
  currency: "USD",
  type: "recurring",
  interval: "month",
  unit_amount: "4900",
  features: proFeatures,
  ...proCommonData,
  variants: proVariantMonthly,
};

export const proYearly: PlanType = {
  planName: PlanName.pro,
  priceIds: pricesById.proPlanYearly,
  currency: "USD",
  type: "recurring",
  interval: "month",
  unit_amount: "3900",
  features: proFeatures,
  ...proCommonData,
  variants: proVariantYearly,
};

export const unlimitedMonthly: PlanType = {
  planName: PlanName.unlimited,
  priceIds: pricesById.unlimitedMonthly,
  currency: "USD",
  type: "recurring",
  interval: "month",
  unit_amount: "4200",
  features: unlimitedFeatures,
  ...unlimitedCommonData,
};

export const unlimiteYearly: PlanType = {
  planName: PlanName.unlimited,
  priceIds: pricesById.unlimitedYearly,
  currency: "USD",
  type: "recurring",
  interval: "year",
  unit_amount: "3200",
  features: unlimitedFeatures,
  ...unlimitedCommonData,
};

export const creatorPlanNewMonthly: PlanType = {
  planName: PlanName.creator,
  priceIds: pricesById.creatorPlanMonthlyNew,
  currency: "USD",
  type: "recurring",
  interval: "month",
  unit_amount: "2500",
  features: creatorFeatures,
  ...creatorNewCommonData,
};

export const creatorPlanNewYearly: PlanType = {
  planName: PlanName.creator,
  priceIds: pricesById.creatorPlanYearlyNew,
  currency: "USD",
  type: "recurring",
  interval: "year",
  unit_amount: "2000",
  features: creatorFeatures,
  ...creatorNewCommonData,
};

export const creatorPlanMonthly: PlanType = {
  planName: PlanName.creator,
  priceIds: pricesById.creatorPlanMonthly,
  currency: "USD",
  type: "recurring",
  interval: "month",
  unit_amount: "2200",
  features: creatorFeatures,
  ...creatorCommonData,
};

export const creatorYearly: PlanType = {
  planName: PlanName.creator,
  priceIds: pricesById.creatorYearly,
  currency: "USD",
  type: "recurring",
  interval: "year",
  unit_amount: "1900",
  features: creatorFeatures,
  ...creatorCommonData,
};

export const appSumoTier1: PlanType = {
  planName: PlanName.appSumoTier1,
  priceIds: pricesById.appSumoTier1,
  currency: "USD",
  type: "recurring",
  interval: "year",
  unit_amount: "1800",
  features: [
    {
      description: "20,000 words per month",
    },
    {
      description: "5 blog post workflow runs per month",
    },
  ],
  wordsPerMonth: 20000,
  imageRestores: 100,
  aiImages: 50,
  advancedWordsPerMonth: 0,
  workflowsPerMonth: 5,
  price: 69,
  isPopular: false,
};
export const appSumoTier2: PlanType = {
  planName: PlanName.appSumoTier2,
  priceIds: pricesById.appSumoTier2,
  currency: "USD",
  type: "recurring",
  interval: "year",
  unit_amount: "1850",
  features: [
    {
      description: "50,000 words per month",
    },
    {
      description: "15 blog post workflow runs per month",
    },
    {
      description: "Integrations: Medium, Reddit, Shopify, WordPress, Webflow",
    },
    {
      description: "Auto internal & external linking",
    },
  ],
  wordsPerMonth: 50000,
  imageRestores: 100,
  aiImages: 50,
  advancedWordsPerMonth: 0,
  workflowsPerMonth: 15,
  price: "129",
};
export const appSumoTier3: PlanType = {
  planName: PlanName.appSumoTier3,
  priceIds: pricesById.appSumoTier3,
  currency: "USD",
  type: "recurring",
  interval: "year",
  maxTeamSize: 3,
  unit_amount: "3500",
  features: [
    {
      description: "100,000 words per month",
    },
    {
      description: "35 blog post workflow runs per month",
    },
    {
      description: "Integrations: Medium, Reddit, Shopify, WordPress, Webflow",
    },
    {
      description: "Auto internal & external linking",
    },
    {
      description:
        "Auto-insert competitor keywords & terms in existing content",
    },
    {
      description: "Schedule publishing",
    },
  ],
  wordsPerMonth: 100000,
  imageRestores: 100,
  aiImages: 80,
  advancedWordsPerMonth: 0,
  workflowsPerMonth: 35,
  price: 239,
};
export const appSumoTier4: PlanType = {
  planName: PlanName.appSumoTier4,
  priceIds: pricesById.appSumoTier4,
  currency: "USD",
  type: "recurring",
  interval: "year",
  maxTeamSize: 4,
  unit_amount: "3600",
  features: [
    {
      description: "200,000 words per month",
    },
    {
      description: "70 blog post workflow runs per month",
    },
    {
      description: "Integrations: Medium, Reddit, Shopify, WordPress, Webflow",
    },
    {
      description: "Auto internal & external linking",
    },
    {
      description:
        "Auto-insert competitor keywords & terms in existing content",
    },
    {
      description: "Schedule publishing",
    },
  ],
  wordsPerMonth: 200000,
  imageRestores: 100,
  aiImages: 100,
  advancedWordsPerMonth: 0,
  workflowsPerMonth: 70,
  price: 399,
  isPopular: false,
};

export const creatorYearlyCn: PlanType = {
  ...creatorYearly,
  features: creatorFeatures,
  ...creatorCommonDataCn,
};

const proPlanMonthlyLegacy = {
  ...creatorPlanMonthly,
  priceIds: pricesById.proMonthlyLegacy,
  workflowsPerMonth: 5,
};
const proPlanYearlyLegacy = {
  ...creatorYearly,
  priceIds: pricesById.creatorYearlyLegacy,
  workflowsPerMonth: 5,
};

const unlimitedMonthlyLegacy = {
  ...unlimitedMonthly,
  priceIds: pricesById.unlimitedMonthlyLegacy,
  workflowsPerMonth: 30,
};
const unlimitedYearlyLegacy = {
  ...unlimiteYearly,
  priceIds: pricesById.unlimitedYearlyLegacy,
  workflowsPerMonth: 30,
};

const allPaidPlans = [
  proPlanMonthlyLegacy,
  proPlanYearlyLegacy,
  unlimitedMonthlyLegacy,
  unlimitedYearlyLegacy,
  unlimitedMonthly,
  unlimiteYearly,
  creatorPlanMonthly,
  creatorYearly,
  creatorPlanNewMonthly,
  creatorPlanNewYearly,
  proMonthly,
  proYearly,
  appSumoTier1,
  appSumoTier2,
  appSumoTier3,
  appSumoTier4,
];

export const getPlanByPriceId = (priceId: string) => {
  const plan = allPaidPlans.find((plan) => plan.priceIds.includes(priceId));
  if (plan?.variants) {
    const foundVariant = plan.variants.find((variant) =>
      variant.priceIds.includes(priceId)
    );
    if (foundVariant) {
      return {
        ...plan,
        ...omit(foundVariant, ["priceIds"]),
      };
    }
  }
  return plan;
};

export const getPlanNameByPriceId = (priceId: string) => {
  return getPlanByPriceId(priceId)?.planName;
};

export const oneTimeCreditPurchase = {
  priceId: pricesById.credits[0],
  currency: "usd",
  type: "recurring",
  interval: "year",
  unit_amount: "1000",
};

export const oneTimeWorkflowPurchase = {
  priceId: pricesById.workflows[0],
  currency: "usd",
  type: "recurring",
  interval: "year",
  unit_amount: "1",
};

const creatorPlanNewPriceIds = [
  ...creatorPlanNewMonthly.priceIds,
  ...creatorPlanNewYearly.priceIds,
];

export const legacyCreatorPlanPriceIds = [
  ...proPlanMonthlyLegacy.priceIds,
  ...proPlanYearlyLegacy.priceIds,
  ...creatorPlanMonthly.priceIds,
  ...creatorYearly.priceIds,
];

export const creatorPlanPriceIds = [
  ...creatorPlanNewPriceIds,
  ...legacyCreatorPlanPriceIds,
];

export const proPlanPriceIds = [...proMonthly.priceIds, ...proYearly.priceIds];

export const allYearlyPriceIds = [
  ...unlimiteYearly.priceIds,
  ...unlimitedYearlyLegacy.priceIds,
  ...proPlanYearlyLegacy.priceIds,
  ...creatorYearly.priceIds,
  ...creatorPlanNewYearly.priceIds,
  ...proYearly.priceIds,
];

export const unlimitedPlanPriceIds = [
  ...unlimitedMonthlyLegacy.priceIds,
  ...unlimitedYearlyLegacy.priceIds,
  ...unlimitedMonthly.priceIds,
  ...unlimiteYearly.priceIds,
];

export const legacyPlanPriceIds = [
  ...unlimitedPlanPriceIds,
  ...legacyCreatorPlanPriceIds,
];

export const appSumoPlans = [
  appSumoTier1,
  appSumoTier2,
  appSumoTier3,
  appSumoTier4,
];
export const appSumoPlanIds = [
  ...appSumoTier1.priceIds,
  ...appSumoTier2.priceIds,
  ...appSumoTier3.priceIds,
  ...appSumoTier4.priceIds,
];

export const oneTimeCreditPurchasePriceIds = [oneTimeCreditPurchase.priceId];
export const oneTimeWorkflowPurchasePriceIds = [
  oneTimeWorkflowPurchase.priceId,
];

export const subscriptionPriceIds = [
  ...unlimitedPlanPriceIds,
  ...creatorPlanPriceIds,
  ...proPlanPriceIds,
];
export const allPriceIds = [
  ...subscriptionPriceIds,
  ...oneTimeCreditPurchasePriceIds,
  ...oneTimeWorkflowPurchasePriceIds,
];

export const wordsPerUsd = 2000;

export const workflowsPerUsd = 1.5;

export const getPlanStatsByPricingMark = (
  planName: PlanName,
  interval: Interval,
  value: number
) => {
  const selectedVariant =
    Interval.monthly === interval ? proVariantMonthly : proVariantYearly;
  if (planName === PlanName.pro) {
    if (value === 35) {
      return selectedVariant[0];
    }
    if (value === 70) {
      return selectedVariant[1];
    }
    if (value === 100) {
      return selectedVariant[2];
    }
  }
  return {};
};
